import { getConsumer } from "@/lib/cable";
import type { RealtimeNotification } from "@/types";

// Subscribe to per-user private notifications (progress + Noticed payloads)
export function subscribeUserNotifications(onReceive: (msg: RealtimeNotification) => void) {
  console.debug("[UserNotifications] Subscribing to WebNotificationsChannel");
  const sub = getConsumer().subscriptions.create(
    { channel: "WebNotificationsChannel" },
    {
      initialized() {
        console.debug("[UserNotifications] Subscription initialized");
      },
      connected() {
        console.debug("[UserNotifications] Connected to WebNotificationsChannel");
      },
      disconnected() {
        console.debug("[UserNotifications] Disconnected from WebNotificationsChannel");
      },
      rejected() {
        console.warn("[UserNotifications] Subscription rejected by server");
      },
      received: (data: RealtimeNotification) => {
        console.debug("[UserNotifications] Received:", data);
        onReceive(data);
      },
    },
  );
  return () => {
    console.debug("[UserNotifications] Unsubscribing from WebNotificationsChannel");
    sub.unsubscribe();
  };
}
